<template>
  <div>
    <div class="yn">
      <app-button class="col-lg-12 col-md-12 col-sm-12 btn-yn" type="div" style="background: #57ad26" variation="primary" v-on:click.native="response(100)">{{$t('op1')}}</app-button>
      <app-button class="col-lg-12 col-md-12 col-sm-12 btn-yn" type="div" style="background: #ea484d" variation="secondary" v-on:click.native="response(0)">{{$t('op2')}}</app-button>
    </div>
  </div>
</template>

<script>
import { translator } from '@/_helpers'

export default {
  name: 'appyn',
  props: ['question', 'colors'],
  components: {
    'app-button': () => import('@binds-tech/binds-design-system/src/components/Button/Button')
  },
  created () {
    if (this.question.language) {
      this.$i18n.locale = translator.getCurrentLocale(this.question.language)
    }
  },
  mounted () {
    this.$root.$on('footer-submit', payload => {
      if (payload) {
        this.response('skip')
      }
    })
  },
  methods: {
    async response (value) {
      let data = {}
      value === 'skip' ? data = { skip: true } : data = { rating: value }
      this.$emit('value-changed', data)
      this.$emit('question-answered', true)
    }
  }

}
</script>
<style lang="scss">
.yn {
  height: 370px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .btn-yn {
    font-size: 19px;
    margin: 20px 0;
    width: 230px;
    height: 45px;
    border-radius: 35px;
    box-shadow: 0 5px 15px 0 rgb(215, 215, 215) !important;
  }
}

// responsivity to mobile
@media only screen and (max-width: 850px) {
  .yn {
    height: 100%;
  }
}
</style>
